import { render, staticRenderFns } from "./ShouldCTScansBePerformed.vue?vue&type=template&id=05c4a008&scoped=true&"
import script from "./ShouldCTScansBePerformed.vue?vue&type=script&lang=js&"
export * from "./ShouldCTScansBePerformed.vue?vue&type=script&lang=js&"
import style0 from "./ShouldCTScansBePerformed.vue?vue&type=style&index=0&id=05c4a008&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c4a008",
  null
  
)

export default component.exports